import moment from 'moment';

import { usersData } from './home.selectors';

export const homeInitialState = {
  home: {
    data: {},
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false
    },
    selectors: {
      usersData,
    },
    filters: {
      startDate: moment().add(-7, 'days'),
      endDate: moment()
    }
  }
};
